module.exports = __webpack_public_path__ + "img/placeholder.6f43c7eb.webp";